import { useState, useEffect } from 'react';

import { getTimeInfo } from '~services/api.helpers';

const useTimeInfo = formId => {
  const [timeInfo, setTimeInfo] = useState();

  useEffect(() => {
    const update = async () => {
      const tempTimeInfo = await getTimeInfo(formId);

      setTimeInfo(tempTimeInfo);
    };
    update();
  }, [formId]);

  return timeInfo;
};

export default useTimeInfo;
